/* Ott-common */
import { ContentType } from '@dtvgo/backend-service';

function normalizeImagesMoreLikeThis(images) {
  if (images) {
    return Object.fromEntries(images.map((image) => [image.ratio, image]));
  }

  return images;
}

export const normalizeMoreLikeThisVOD = (vod) => {
  if (vod) {
    return {
      ...vod,
      images: normalizeImagesMoreLikeThis(vod.images),
    };
  }
  return {};
};

export const normalizeMoreLikeThisEPG = (epg) => {
  if (epg) {
    return {
      ...epg,
      startTime: epg.startTime ? new Date(epg.startTime) : undefined,
      endTime: epg.endTime ? new Date(epg.endTime) : undefined,
      images: normalizeImagesMoreLikeThis(epg.images),
      live: {
        channelId: epg?.channelId,
        startTime: new Date(epg.startTime),
        endTime: new Date(epg.endTime),
      },
      type: ContentType.CHANNEL,
    };
  }
  return {};
};
